import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class WildFire20_3 extends SlotGameType1_3{}